import { deleteList as deleteListRequest } from '@vlabs/api/artemy/client';

import {
  deleteAllCardsFromList,
  detachAllCardsFromList,
} from './requests';

export type DeleteListsAction = 'delete_content' | 'detach_content';

export interface DeleteListsProps {
  listIds: string[];
  action: DeleteListsAction;
}

export async function deleteLists({
  listIds,
  action,
}: DeleteListsProps): Promise<void> {
  await listIds.reduce(async (previousPromise, listId) => {
    await previousPromise;

    if (action === 'delete_content') {
      await deleteAllCardsFromList(listId);
    } else {
      await detachAllCardsFromList(listId);
    }
    await deleteListRequest(listId);
  }, Promise.resolve());
}
